<template>
  <div
    class="cta-message"
  >
    <h4 class="cta-message__title">
      {{ $t("Benchmarks.pages.compare.instructions.title") }}
    </h4>
    <p class="cta-message__subtitle">
      {{ $t("Benchmarks.pages.compare.instructions.subtitle") }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'CTAMessage',
};
</script>

<style lang="scss" scoped>
.cta-message {
  padding-top: 162px;

  &__title {
    font-weight: var(--ds-font-weight-semibold);
    font-size: var(--ds-font-size-baseline);
    text-align: center;
    color: var(--ds-color-text-dark);
  }

  &__subtitle {
    font-weight: normal;
    padding-top: var(--ds-spacing-stack-nano);
    font-size: var(--ds-font-size-sm);
    line-height: 20px;
    text-align: center;
    color: var(--ds-color-text-2);
  }
}
</style>
